import {SET_OPTIONS} from '../actions/options.action.js';
import {mixins} from 'ereader-core/dist/utils.mixins.js';
import {default_state} from './index.js';

export function options(state = default_state.options, action={}){
    if (action.type != SET_OPTIONS) return state;

    let user = state.user;

    let options = mixins.Options.setOptions(state, action.options);
    options.user = mixins.Options.setOptions(user, action.options.user || {});

    return options;
}


// WEBPACK FOOTER //
// ./src/reducers/options.reducer.js